<template lang="pug">
apis
errors
events
pathes
</template>

<style>
</style>

<script>
import apis from "./apis.vue";
import errors from "./errors.vue";
import events from "./events.vue";
import pathes from "./pathes.vue";

export default {
  components: {
    apis,
    errors,
    events,
    pathes,
  },
};
</script>
